// removed by extract-text-webpack-plugin
module.exports = {"container":"_14EA8","section":"_1kjfI","count":"_1Pu3u","label":"_1bmix"};


//////////////////
// WEBPACK FOOTER
// ./app/components/profile-stats/profile-stats.scss
// module id = 1763
// module chunks = 0